import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {
  trackFitAnalytics,
  TrackingProduct,
} from '@aboutyou/legacy-tracking-sdk';
import {useCallback} from 'react';
// eslint-disable-next-line monorepo/no-internal-import
import {useTracking} from '@aboutyou/tracking/src/utils/utils';

export function useTrackFitAnalytics(product: Product) {
  const {TrackingClient} = useTracking();

  return useCallback(
    (action: 'start' | 'complete' | 'close' | 'update', value?: string) => {
      const trackingProduct = mapProductToTracking(product);

      TrackingClient.track(
        trackFitAnalytics({
          product: trackingProduct,
          action,
          value,
        }),
      );
    },
    [TrackingClient, product],
  );
}

function mapProductToTracking(product: Product): TrackingProduct {
  return {
    id: product.id,
    name: product.name,
    brand: {},
    colors: [],
    minPrice: product.price?.minPrice,
    isSoldOut: product.isSoldOut,
    url: product.shareUrl,
    masterKey: product.masterKey || '',
    isSponsored: product.isSponsored,
    sponsoredType: product.sponsoredType,
  } as unknown as TrackingProduct;
}
